import styled from 'styled-components';

export const ButtonDownloadContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 790px;
  margin-bottom: 20px;
  a {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 26px 25px 26px 32px;
    border: 1px solid #010e54;
    box-sizing: border-box;
    border-radius: 16px;
    &:hover {
      background: #e6e7ee;
      svg {
        path {
          fill: #010e54 !important;
        }
      }
    }
  }
`;
